import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import '../styles/index.css';

const HeaderEN = ({ currentPage = '', lang = 'en' }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const switchToFrench = () => {
    const routeMap = {
      '': '/',
      'caterers': '/caterers',
      'parents': '/parents',
      'schools': '/schools',
      'directions': '/directions',
      'platform': '/platform',
      'ecopulse': '/ecopulse',
      'ecoloop': '/ecoloop',
      'css': '/css',
      'coparentalite': '/coparentalite'
    };
    navigate(routeMap[currentPage] || '/');
  };

  const navTo = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <nav className="nav-header">
      <div className="nav-content">
        <div className="nav-logo" onClick={() => navTo('/en')}>
          <img src="/logo-ecolunch.png" alt="EcoLunch" className="logo-image" />
        </div>
        <button className="nav-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <div className={`nav-overlay ${menuOpen ? 'nav-overlay-visible' : ''}`} onClick={() => setMenuOpen(false)}></div>
        <div className={`nav-links ${menuOpen ? 'nav-open' : ''}`}>
          <a onClick={() => navTo('/en')} className={`nav-link nav-btn-feature ${currentPage === 'home' ? 'nav-btn-feature-active' : ''}`}>Home</a>
          <a onClick={() => navTo('/en/parents')} className={`nav-link nav-btn-actor nav-btn-parents ${currentPage === 'parents' ? 'nav-btn-active' : ''}`}>Parents</a>
          <a onClick={() => navTo('/en/caterers')} className={`nav-link nav-btn-actor nav-btn-caterers ${currentPage === 'caterers' ? 'nav-btn-active' : ''}`}>Caterers</a>
          <a onClick={() => navTo('/en/schools')} className={`nav-link nav-btn-actor nav-btn-schools ${currentPage === 'schools' ? 'nav-btn-active' : ''}`}>Schools</a>
          <a onClick={() => navTo('/en/directions')} className={`nav-link nav-btn-actor nav-btn-directions ${currentPage === 'directions' ? 'nav-btn-active' : ''}`}>Boards</a>
          <a onClick={() => navTo('/en/css')} className={`nav-link nav-btn-actor nav-btn-css ${currentPage === 'css' ? 'nav-btn-active' : ''}`}>CSS</a>
          <a onClick={() => navTo('/en/platform')} className={`nav-link nav-btn-feature ${currentPage === 'platform' ? 'nav-btn-feature-active' : ''}`}>Architecture</a>
          <a onClick={() => navTo('/en/ecoloop')} className={`nav-link nav-btn-feature ${currentPage === 'ecoloop' ? 'nav-btn-feature-active' : ''}`}>EcoLoop</a>
          <a onClick={() => navTo('/en/coparenting')} className={`nav-link nav-btn-feature ${currentPage === 'coparentalite' ? 'nav-btn-feature-active' : ''}`}>Co-Parenting</a>
          <a onClick={() => navTo('/en/ecopulse')} className={`nav-link nav-btn-feature ${currentPage === 'ecopulse' ? 'nav-btn-feature-active' : ''}`}>EcoPulse</a>
          <div className="lang-selector">
            <button className={`lang-btn ${lang === 'fr' ? 'active' : ''}`} onClick={switchToFrench}>FR</button>
            <button className={`lang-btn ${lang === 'en' ? 'active' : ''}`} onClick={() => navigate(currentPage ? { '': '/en', 'caterers': '/en/caterers', 'parents': '/en/parents', 'schools': '/en/schools', 'directions': '/en/directions', 'css': '/en/css', 'platform': '/en/platform', 'ecopulse': '/en/ecopulse', 'ecoloop': '/en/ecoloop', 'coparentalite': '/en/coparenting' }[currentPage] || '/en' : '/en')}>EN</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderEN;
